import { render } from "./ItemListGarmet.vue?vue&type=template&id=6c7015ca&scoped=true"
import script from "./ItemListGarmet.vue?vue&type=script&lang=js"
export * from "./ItemListGarmet.vue?vue&type=script&lang=js"

import "./ItemListGarmet.vue?vue&type=style&index=0&id=6c7015ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c7015ca"]])

export default __exports__